export const changeObjectToArrayWithTrueValues = (group: any): string[] => {
    return Object.keys(group).filter((key) => group[key]);
};
